var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-section',{attrs:{"id":"konst"}},[_c('base-section-heading',{attrs:{"title":"2024","subtitle":"Konst har ingen uppgift"}}),_c('v-container',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('base-img',{attrs:{"max-width":"100%","src":require(`@/assets/konst.jpg`)}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }